import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';


const Onboarding = lazy(() => import('./Onboarding'));

const OnboardingRoutes: FuseRouteItemType[] = [
  {
    path: 'accreditation/',
    element: <Onboarding />,
    settings: {
      layout: {
        config: {
          toolbar: {
            title: 'Accreditation',
            showCrumbs: false,
          },
        },
      },
    },
  },

];

export default OnboardingRoutes;
